
export const menuItems = [
    { name: 'Home', icon: '', link: '/' },
    {
        name: 'About', icon: '', link: '',
        subMenu: [
            { name: 'Institute', link: '/aboutus' },
            { name: 'Principal\'s Desk', link: '/principal' },
            { name: 'Faculty', link: '/faculty' }]
    },
    { name: 'Admission', icon: '', link: '/admission' },
    { name: 'Training & Placement', icon: '', link: '/TnPcell' },
    {
        name: 'Activities', icon: '', link: '',
        subMenu: [
            { name: 'Academic', link: '/academic' },
            { name: 'Student Corner', link: '/student' },
            { name: 'Gallery', icon: '', link: '/gallery' },
            { name: 'Alumni', icon: '', link: '/alumni' },
            { name: 'Grievance Portal', icon: '', link: '/grievance' },
        ]
    },
    {
        name: 'News & Events', icon: '', link: ''
        , subMenu: [
            { name: 'Academic', link: '/news' },
            { name: 'Cultural', link: '/cultural-news' }
        ]
    },
    { name: 'Contact us', icon: '', link: '/contact' }];
